import { useMutation, useQueryClient } from "react-query";
import { useNotify } from "react-admin";
import gql from "graphql-tag";
import { graphqlFetch } from "../../../lib/graphqlClient";

export interface TransferVirtualMsisdnInput {
  new_user_id: string;
  old_user_id: string;
  virtual_msisdn: string;
}

export interface TransferVirtualMsisdnResponse {
  data?: any;
  error?: string;
  status: string;
}

export const useTransferVirtualMsisdn = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const mutation = useMutation(
    (variables: { input: TransferVirtualMsisdnInput }) => {
      return graphqlFetch<TransferVirtualMsisdnResponse>({
        query:
          gql`
            mutation transferVN($input: TransferVirtualMsisdnInput!) {
              transferVirtualMsisdn(input: $input) {
                data
                error
                status
              }
            }
          `.loc?.source?.body || "",
        variables,
      });
    },
    {
      onSuccess: (data) => {
        const result = (data as any)?.data?.transferVirtualMsisdn;

        if (result?.error) {
          notify(`Error: ${result?.error}`, { type: "error" });
        } else {
          notify("Virtual number transferred successfully", {
            type: "success",
          });
        }

        queryClient.invalidateQueries(["subscribers"]);
      },
      onError: (error: Error) => {
        notify(`Error transferring virtual number: ${error.message}`, {
          type: "error",
        });
      },
    }
  );

  return {
    transferVirtualMsisdn: mutation,
    transferVirtualMsisdnAsync: (input: TransferVirtualMsisdnInput) =>
      mutation.mutateAsync({ input }),
  };
};
